import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';

export default function DigitalPublicInfrastructureBasicInfoComponent ({digitalPublicInfrastructure,handleInnerFormChange, selectedDigitalPublicInfrastructure}: any) {

  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                )
              }}
              type="text"
              value={selectedDigitalPublicInfrastructure?.Name}
          />
        <InputContainer

label="Service"
name="Service"
onValueChange={(event: any) => {
  handleInnerFormChange(
    event.target.value,
    'Service',

  )
}}
type="text"
value={selectedDigitalPublicInfrastructure?.Service}
/>
        <InputContainer

label="Type"
name="Type"
onValueChange={(event: any) => {
  handleInnerFormChange(
    event.target.value,
    'Type',

  )
}}
type="text"
value={selectedDigitalPublicInfrastructure?.Type}
/>
<InputContainer

    label="Cost"
    name="Cost"
    onValueChange={(event: any) => {
      handleInnerFormChange(
        event.target.value,
        'Cost',
    
      )
    }}
    type="number"
    value={selectedDigitalPublicInfrastructure?.Cost}
/>
<InputContainer

    label="Enabled"
    name="IsEnabled"
    onValueChange={(event: any) => {
      handleInnerFormChange(
        event,
        'IsEnabled',
    
      )
    }}
    type="checkbox"
    value={selectedDigitalPublicInfrastructure?.IsEnabled}
/>

<InputContainer

    label="Parent"
    name="IsParent"
    onValueChange={(event: any) => {
      handleInnerFormChange(
        event,
        'IsParent',
    
      )
    }}
    type="checkbox"
    value={selectedDigitalPublicInfrastructure?.IsParent}
/>

{selectedDigitalPublicInfrastructure?.IsParent
       && <InputContainer
       label="Parent Name"
       labelField="Name"
       list={digitalPublicInfrastructure}
       onValueChange={(event: any) => {
        handleInnerFormChange(
          event.target.value,
          'ParentId',
      
        )
       }}
       optionName="Choose ParentName"
       type="select"
       value={selectedDigitalPublicInfrastructure.ParentId}
       valueField="Id"
   />}
</div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}